import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

const RESIZE_OBSERVER_ERRORS = [
  'ResizeObserver loop completed with undelivered notifications',
  'ResizeObserver loop limit exceeded'
]

const isResizeObserverError = (error) => {
  const message = typeof error === 'string' ? error : error?.message
  if (!message) return false
  return RESIZE_OBSERVER_ERRORS.some((knownMessage) => message.includes(knownMessage))
}

window.addEventListener('error', (event) => {
  if (isResizeObserverError(event.error) || isResizeObserverError(event.message)) {
    event.stopImmediatePropagation()
  }
}, true)

window.addEventListener('unhandledrejection', (event) => {
  if (isResizeObserverError(event.reason)) {
    event.preventDefault()
  }
}, true)

const app = createApp(App)

app.use(router)
app.use(store)
app.use(vuetify)

app.mount('#app') 